import { CollapsibleSection } from 'cpool-components/general/CollapsibleSection';

type Props = {
    children: React.ReactNode;
    title: string;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    testId?: string;
};

// Empty button text so only the chevron shows — matches the Figma User Info mock.
export const PanelSection = ({ children, onOpenChange, open, testId, title }: Props) => (
    <CollapsibleSection
        title={title}
        titleClassNames="text-sm text-midnight font-medium"
        buttonTextOpen=""
        buttonTextClosed=""
        bgClassNames="bg-white border-b border-outline-light rounded-none px-4 py-3"
        open={open}
        onOpenChange={onOpenChange}
        testId={testId}
    >
        {children}
    </CollapsibleSection>
);
